import React from 'react';
import { Mail, Linkedin, Github, ExternalLink } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] border-t border-[#2a2a2a] py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo/Name */}
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-white mb-2">Sadasiva Velkuri</h3>
            <p className="text-[#a3a3a3] text-sm">Data Principal | Data Architect</p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a 
              href="mailto:sadasiva.velkuri@example.com" 
              className="text-[#a3a3a3] hover:text-white transition-colors"
              aria-label="Email"
            >
              <Mail className="h-5 w-5" />
            </a>
            <a 
              href="https://linkedin.com/in/sadasiva-velkuri" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#a3a3a3] hover:text-white transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <a 
              href="https://github.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#a3a3a3] hover:text-white transition-colors"
              aria-label="GitHub"
            >
              <Github className="h-5 w-5" />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-[#2a2a2a] text-center">
          <p className="text-[#666666] text-sm">
            © {currentYear} Sadasiva Velkuri. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
